<template>
  <div class="edit-user">
    <page-title>
      <template v-if="isMyProfile">
        {{ $t('employees.edit_my_profile') }}
      </template>
      <template v-else>{{ $t('employees.edit_profile') }}</template>
      <template v-if="user && !isMyProfile">:
        <router-link :to="{ path: '/users/'+user.getId()+'', params: { id: user.getId() } }">
          {{user.getFullName()}}
        </router-link>
      </template>
    </page-title>
    <el-tabs v-model="activeTab" v-if="!loadingUser && user">
      <el-tab-pane :label="$t('employees.steps.step1')" name="first">
        <edit-account @updateData="updateUser"
                      @updateFailed="updateFailed"
                      :isMyProfile="!isAdmin && isMyProfile"
                      :user="user"></edit-account>
      </el-tab-pane>
      <el-tab-pane :label="$t('employees.steps.step2')" name="second">
        <edit-workplaces v-if="!loadingUser"
                         :user="user"
                          @updateData="updateUser"
                          @updateFailed="updateFailed"></edit-workplaces>
      </el-tab-pane>
      <el-tab-pane :label="$t('employees.steps.step3')" name="fourth">
        <edit-user-data @updateData="updateUser"
                        v-if="user"
                        :user="user"
                        :isMyProfile="!isAdmin && isMyProfile"
                        @updateFailed="updateFailed"></edit-user-data>
      </el-tab-pane>
    </el-tabs>
    <template v-else-if="!loadingUser && !user">
      <div class="edit-user-not-found">
        <div class="edit-user-not-found__text">
          {{ $t('labels.user_data_not_found') }}
        </div>
        <router-link to="/">{{ $t('labels.to_main_page') }}</router-link>
      </div>
    </template>
  </div>
</template>
<script>
  // import admin from 'src/api/admin';
  // import personal from 'src/api/personal';
  import editAccount from 'src/components/Users/UserEdit/account.vue'
  import editWorkplaces from 'src/components/Users/UserEdit/workplaces.vue'
  import editUserData from 'src/components/Users/UserEdit/userData.vue'
  import {USER_ROLE_ADMIN} from '@/constants'

  export default {
    name: 'UserEdit',
    props: ['id'],
    components: {
      editAccount,
      editWorkplaces,
      editUserData
    },
    data () {
      return {
        activeTab: 'first',
        profile: null,
        loadingUser: true,
        loadedProfile: false
      }
    },
    computed: {
      user () {
        return this.$store.state.users.users[this.id];
      },
      isMyProfile () {
        return this.id === this.$store.state.user.user.id;
      },
      isAdmin () {
        return this.$store.state.user.user.checkRole(USER_ROLE_ADMIN)
      }
    },
    methods: {
      async loadUser () {
        this.loadedProfile = false;
        this.loadingUser = false;
        this.$store.dispatch('users/loadUser', this.id);

        if (this.isMyProfile) {
          this.$store.dispatch('user/loadUser')
        }
      },
      updateUser () {
        this.loadUser();
        this.$notify({
          // @ts-ignore
          title: this.$t('students.profile_updated'),
          type: 'success',
          offset: 75
        })
      },
      updateFailed () {
        this.$notify({
          // @ts-ignore
          title: this.$t('labels.error'),
          // @ts-ignore
          message: this.$t('labels.can_not_update_profile'),
          type: 'error',
          offset: 75
        })
      }
    },
    async mounted () {
      await this.loadUser()
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';

.edit-user {
  .el-tabs {
    &__nav-wrap {
      padding: 0 30px;
      background: #fff;
      border-radius: $global-radius;
      box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.05);

      &:after {
        display: none;
      }
    }

    &__content {
      overflow: visible;
    }

    &__item {
      font-weight: 400;
      color: $secondary-font-color;

      &.is-active {
        color: #1989FA;
      }
    }

    &__active-bar {
      height: 3px;
      background-color: #1989FA;
    }
  }
}

.edit-user-not-found {
  a {
    color: $link-color;
  }
}
</style>